export default "__VITE_ASSET__DNfUmDAb__"